<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  font-size: 14px !important;
  position: fixed;
}
.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
*,body,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,input,li,ol,p,pre,textarea,ul{margin:0;padding:0}.fl,.fr{display:inline}.clearfix:after,.hidden{visibility:hidden}a{text-decoration:none;color:#000;transition:color .3s}a:hover{color:#1a97d0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong{font-style:normal;font-weight:400}li,ol,ul{list-style:none}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:' '}.tr{text-align:right}.fl{float:left}.fr{float:right}.clearfix:after{content:"";display:block;height:0;clear:both}*html .clearfix{height:1%}.clearfix{display:block}.vm{vertical-align:center}.pr{position:relative}.abs-right,.pa{position:absolute}.abs-right{right:0}.zoom{zoom:1}.none{display:none}.overhidden{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}body{font-family:"Microsoft YaHei"}

</style>



// WEBPACK FOOTER //
// src/App.vue